import React from 'react';
import SelectField from '../SelectField/SelectField';
import MultiSelectField from '../MultiSelectField/MultiSelectField';
import { Utils } from '../../services';

export const userLabel = (user) => {
    if (!user)
        return '';

    if (user.fullname)
        return user.fullname;

    const fromName = [user.firstname, user.lastname].filter(Boolean).join(' ').trim();
    if (fromName)
        return fromName;

    return user.email ?? user.id ?? '';
};

export const userPhone = (user) => {
    if (!user)
        return '';
    return user.mobile_phone || user.pro_phone || user.fix_phone || '';
};

export const userLabelWithPhone = (user) => {
    const label = userLabel(user);
    const phone = userPhone(user);
    if (!phone)
        return label;
    return `${label} (${Utils.formatPhoneNumber(phone)})`;
};

const UsersField = ({ users, single, name, ...rest }) => {

    if (!users)
        return null;

    const options = [...users].sort((a, b) => userLabel(a).localeCompare(userLabel(b))).map((user) => ({
        key: user.id,
        text: userLabel(user),
        value: user.id
    }));

    return single ? (
        <SelectField name={ name } options={ options } {...rest} />
    ) : (
        <MultiSelectField name={ name } options={ options } {...rest} />
    );
}

export default UsersField;
